export interface TabDef {
  key: string;
  labelKey: string;
  /** 最大允許 role_level（例如 2 = dev/admin, 4 = usermanager 以上） */
  requiredLevel?: number;
}

export interface PageTabConfig {
  tabs: TabDef[];
  defaultTab: string;
}

/**
 * 各頁面的 Header Tab 定義。
 * 新增頁面 Tab 只需在此新增一筆，不需修改 Header.tsx 或 systemStore.ts。
 */
export const PAGE_TABS: Record<string, PageTabConfig> = {
  '/monitoring': {
    // 分頁改由 devices.mashiu.yml catalog 動態提供（系統圖/溫度總覽/1F-1/1F-2/2F）。
    // 移除美濃靜態分頁（預冷室 cold / 變頻冷凍主機 hitachi / 數據採集紀錄器 iot627）；
    // 暫留 AI 控箱(aibox)，待併入 AI 振動量測頁後再移除。
    defaultTab: 'brine',
    tabs: [
      // 靜態 tab 會 append 在 catalog（…冷藏區2F）之後、依此陣列順序 → bch 在 aibox 前
      { key: 'bch', labelKey: 'device.bch' },
      { key: 'aibox', labelKey: 'device.aiBox' },
    ],
  },
  '/vibration': {
    // 馬修 AI 振動量測為單一頁（EHI 卡片），不需美濃子分頁
    defaultTab: 'realtime',
    tabs: [],
  },
  '/system': {
    defaultTab: 'status',
    tabs: [
      { key: 'status', labelKey: 'system.status' },
      { key: 'users', labelKey: 'system.users', requiredLevel: 4 },
      { key: 'settings', labelKey: 'system.settings', requiredLevel: 2 },
      // 2026-10-17 Frank：關於／下載 搬到左側選單「資訊」(/info)，此處不再列。
      // 舊書籤 /system?tab=about|download 由 App.tsx 導向 /info。
    ],
  },
  '/info': {
    // 資訊（獨立頁，2026-10-17）：系統資訊｜關於｜操作說明｜下載
    defaultTab: 'sysinfo',
    tabs: [
      // sysinfo 需要後端 /api/system/info（已於階段 2 完成，權限 /info:sysinfo 等級 4）
      { key: 'sysinfo', labelKey: 'info.sysinfo', requiredLevel: 4 },
      { key: 'about', labelKey: 'info.about' },
      { key: 'manual', labelKey: 'info.manual' },
      { key: 'download', labelKey: 'info.download' },
    ],
  },
  '/report': {
    defaultTab: 'generate',
    tabs: [
      { key: 'generate', labelKey: 'report.generate' },
      { key: 'schedules', labelKey: 'report.schedules', requiredLevel: 2 },
    ],
  },
  '/alarm': {
    defaultTab: 'list',
    tabs: [
      { key: 'list', labelKey: 'alarm.list' },
      { key: 'trend', labelKey: 'alarm.trend' },
      { key: 'custom_rules', labelKey: 'alarm.customRules', requiredLevel: 2 },
      { key: 'escalation', labelKey: 'alarm.escalation', requiredLevel: 2 },
    ],
  },
  '/history': {
    defaultTab: 'chart',
    tabs: [
      { key: 'chart', labelKey: 'history.chart' },
      { key: 'table', labelKey: 'history.table' },
    ],
  },
};
